import {useEffect, useRef} from 'react';
import ReactDOM from 'react-dom';
import {useReducedMotion, motion} from 'framer-motion';
import ModalDelete from './components/ModalDelete/ModalDelete';
import ModalStatus from './components/ModalStatus/ModalStatus';
import {modalVariants} from '../../utilities/framerVariants';
import styles from './Modal.module.scss';
import {useDispatch, useSelector} from "react-redux";
import {closeModal} from "../../store/actions/modalActions";
import ModalStatusUser from "./components/ModalStatusUser/ModalStatusUser";
import ModalDeleteUser from "./components/ModalDeleteUser/ModalDeleteUser";

const Modal = () => {
    const dispatch = useDispatch();
    const { isModalOpen, modalName, modalData } = useSelector((state) => state.modal);
    const modalRef = useRef();
    const shouldReduceMotion = useReducedMotion();
    const variant = (element) => {
        return shouldReduceMotion
            ? modalVariants.reduced
            : modalVariants[element];
    };
    const containerVariant = variant('container');

    const focusTrap = (event) => {
        if (event.key === 'Escape') dispatch(closeModal());
        if (event.key !== 'Tab') return;

        const modalElements = modalRef.current.querySelectorAll('button');
        const firstElement = modalElements[0];
        const lastElement = modalElements[modalElements.length - 1];

        if (!event.shiftKey && document.activeElement === lastElement) {
            firstElement.focus();
            event.preventDefault();
        }

        if (event.shiftKey && document.activeElement === firstElement) {
            lastElement.focus();
            event.preventDefault();
        }
    };

    const handleClickOutsideModal = (event) => {
        const target = event.target;
        if (target === modalRef.current) dispatch(closeModal());
    };

    useEffect(() => {
        document.addEventListener('keydown', focusTrap);
        document.addEventListener('click', handleClickOutsideModal);
        modalRef.current.focus();
        document.body.style.overflow = 'hidden';

        return () => {
            document.removeEventListener('keydown', focusTrap);
            document.removeEventListener('click', handleClickOutsideModal);
            document.body.style.overflow = 'unset';
        };
    }, []);

    console.log(useSelector((state) => state.modal));

    if (!isModalOpen) {
        return null;
    }

    const modal = (
        <motion.div
            className={styles.modal}
            aria-modal
            aria-label="Confirmation"
            tabIndex={-1}
            role="dialog"
            ref={modalRef}
            variants={variant('modal')}
            initial="hidden"
            animate="visible"
            exit="exit"
        >
            {modalName === 'deleteUser' && <ModalDeleteUser variants={containerVariant} data={modalData} />}
            {modalName === 'statusUser' && <ModalStatusUser variants={containerVariant} data={modalData} />}
            {modalName === 'delete' && <ModalDelete variants={containerVariant} />}
            {modalName === 'status' && <ModalStatus variants={containerVariant} />}
        </motion.div>
    );

    return ReactDOM.createPortal(modal, document.body);
};

export default Modal;
